// extracted by mini-css-extract-plugin
module.exports = {"swiper":"ImageCarousel_swiper__1r6mp","itemWrapper":"ImageCarousel_itemWrapper__AWR_b","imageWrapper":"ImageCarousel_imageWrapper__1vdg0","title":"ImageCarousel_title__2nKXc"};